import React from 'react';
import { injectIntl } from 'react-intl';
import { map, get } from 'lodash';

const CategoryDropdown = ({ availableFacets, facetId, handleChange, intl }) => {
  const segments = get(availableFacets, 'category.data', []);

  const segmentNames = map(segments, (segment) => {
    const id = get(segment, 'id');
    return <option key={id} value={id}>{get(segment, 'label')}</option>
  });

  return (
    <select className="form-control input-lg segment" value={facetId ? facetId : "all"} onChange={handleChange}>
      <option key="all" value="">
        {intl.formatMessage({ id: 'category.select.placeholder' })}
      </option>
      {segmentNames}
    </select>
  );
};

export default injectIntl(CategoryDropdown);



// WEBPACK FOOTER //
// ./src/views/recalls-list/category-dropdown.js